import { useDocumentTitle } from '@pidelo/web-core';
import { EmptyState, PageHeader, buttonClassName } from '@pidelo/web-ui';
import { MapPin } from 'lucide-react';
import { Link } from 'react-router';

export function NotFoundPage() {
  useDocumentTitle('No existe · Pídelo Admin');
  return (
    <>
      <PageHeader title="Esta página no existe" />
      <EmptyState
        icon={<MapPin />}
        title="No encontramos lo que buscas"
        action={
          <Link to="/" className={buttonClassName({ variant: 'ghost' })}>
            Ir al inicio
          </Link>
        }
      >
        Puede que el enlace esté mal copiado o que la sección haya cambiado de lugar.
      </EmptyState>
    </>
  );
}
